import * as React from 'react';
import { Radio } from 'antd';
import StaticView from './StaticView';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default (config: any) => {
    const { plain, options, onChange, disabled, vertical, staticView, adaptFn, className, value } = config;
    const verticalStyle = {
        display: 'block'
    };
    const onChangeHandler = (e: any) => {
        if (onChange) onChange(e.target.value);
    };
    const getClassName = (base: string): string => {
        const classes = [base];
        className && classes.push(className);
        return classes.join(' ');
    };
    return options && (
        (staticView && disabled) ? <StaticView adaptFn={() => adaptFn && adaptFn(options)}/> :
            plain ? <RadioGroup
                className={getClassName('RadioGroup')}
                onChange={onChangeHandler}
                disabled={disabled}
                value={value}
            >
                {options.map((item: any, index: number) => (
                    <Radio style={vertical ? verticalStyle : null}
                           disabled={item.disabled}
                           value={item.value}
                           checked={item.checked}
                           key={index}>
                        {item.label}
                    </Radio>
                ))}
            </RadioGroup>
            : <RadioGroup
                className={getClassName('RadioGroup')}
                onChange={onChangeHandler}
                disabled={disabled}
                value={value}
            >
                {options.map((item: any, index: number) => (
                    <RadioButton className="RadioGroup-button" style={vertical ? verticalStyle : null} disabled={item.disabled} value={item.value} key={index}>
                        <span className='RadioGroup-button-text' style={{ padding: 20 }}>{item.label}</span>
                    </RadioButton>
                ))}
            </RadioGroup>
    );
};
